import { Icon, IconsEnum } from 'components/Icons';
import styles from './AuthenticatedPin.module.scss';
import { useIsManifestazionePreferito } from 'features/sport/components/sportNav/hooks';
import { useAppDispatch } from 'lib/centralStore';
import { updatePreferitiManifestazione } from 'features/sport/components/sportNav/actions';

type AuthenticatedPinProps = {
  id: string;
  slug: string;
  descrizione?: string;
};

export const AuthenticatedPin = ({ id, slug, descrizione }: AuthenticatedPinProps) => {
  const isPreferito = useIsManifestazionePreferito(id);
  const dispatch = useAppDispatch();
  return (
    <button
      type="button"
      className={styles.button}
      onClick={() =>
        dispatch(
          updatePreferitiManifestazione({
            id,
            slug,
            descrizione,
            method: isPreferito ? 'delete' : 'add',
          })
        )
      }
    >
      <Icon
        iconId={isPreferito ? IconsEnum.FULL_PIN : IconsEnum.PIN}
        className={styles.icon}
        color={isPreferito ? 'var(--color-primary)' : 'var(--color-on-bg-primary)'}
      />
    </button>
  );
};